import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Grid, Typography } from "@mui/material";
import { t } from "i18next";
import { useForm, useWatch } from "react-hook-form";
import { z } from "zod";
import { FORM_ERR } from "../../../helpers/constants";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { useToasts } from "../../../hooks/useToasts";
import BasicDialog from "../../base/BasicDialog";
import { SearchOtherClientButton } from "../../button/SearchOtherClientButton/SearchOtherClientButton";
import { ControlledSelect } from "../../form/ControlledSelect/ControlledSelect";
import { ControlledTextField } from "../../form/ControlledTextField/ControlledTextField";
import { SearchOtherClientDialog } from "../ClientDiscoveryDialog/SearchOtherClientDialog";

// TODO validate if existingClient is false even when existingClientId is provided
export const connectedPersonFormSchema = z.object({
    existingClient: z.boolean(),
    exisitngClientPersonId: z.string().optional(),

    name: z.string().nonempty({ message: FORM_ERR.name_required }),
    surname: z.string().nonempty({ message: FORM_ERR.surname_required }),
    role: z.string().optional(),
    phone: z.string().optional(),
    email: z.string().email(),
});

export function AddConnectedPersonDialog(props) {
    const { handleSubmit, control, setValue } = useForm({
        resolver: zodResolver(connectedPersonFormSchema),
        defaultValues: {
            existingClient: false,
            phone: "",
            email: "",
            name: "",
            surname: "",
        },
    });

    const existingClient = useWatch({
        control,
        name: "existingClient",
    });

    const { onFormErrors } = useToasts();
    const { closeDialog: closeSearchOtherClientDialog, openDialog: openSearchOtherClientDialog } =
        useDialogBetter();

    const onSubmit = (data) => {
        console.log(data);
        props.onSubmit(data);
        props.onClose();
    };

    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("clients.connectedPersonDialog.title")}
            maxWidth={"sm"}
            showDialogActions
            titleSx={{
                pb: 0,
            }}
            headerComponent={
                <Typography
                    variant={"subtitle1"}
                    sx={{ color: "text.secondary", mx: "auto", mb: 1 }}
                >
                    {t("clients.connectedPersonDialog.subtitle")}
                </Typography>
            }
        >
            <Grid container direction={"column"}>
                <Grid container>
                    <Grid
                        container
                        sx={{ mt: 0 }}
                        direction={"row"}
                        justifyContent={"start"}
                        alignItems={"center"}
                        spacing={2}
                    >
                        <Grid item xs={6}>
                            <ControlledSelect
                                label={t("clients.connectedPersonDialog.clientExists")}
                                control={control}
                                name="existingClient"
                                data={[
                                    { label: t("clients.connectedPersonDialog.yes"), value: true },
                                    { label: t("clients.connectedPersonDialog.no"), value: false },
                                ]}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <SearchOtherClientButton
                                fullWidth
                                onClick={() => {
                                    openSearchOtherClientDialog({
                                        Component: SearchOtherClientDialog,
                                        componentProps: {
                                            clientId: props.clientId,
                                            title: t("clients.connectedPersonDialog.searchClient"),
                                            onCustomerSelected: (customer) => {
                                                console.log(customer);
                                                closeSearchOtherClientDialog();
                                                setValue(
                                                    "email",
                                                    customer.person?.email.email_address || "",
                                                );
                                                setValue("name", customer.person.name);
                                                setValue("surname", customer.person.surname);
                                                setValue(
                                                    "phone",
                                                    customer.person?.phone.phone_number || "",
                                                );

                                                setValue(
                                                    "exisitngClientPersonId",
                                                    customer.person?.id,
                                                );
                                            },
                                        },
                                    });
                                }}
                                disabled={!existingClient}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        direction={"column"}
                        sx={{ mt: 3 }}
                        gap={1}
                        justifyContent={"center"}
                    >
                        <Grid container justifyContent={"center"}>
                            <Grid item xs={6}>
                                <ControlledTextField
                                    control={control}
                                    name="name"
                                    label={t("clients.connectedPersonDialog.firstName")}
                                    props={{
                                        fullWidth: true,
                                        size: "small",
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container justifyContent={"center"}>
                            <Grid item xs={6}>
                                <ControlledTextField
                                    control={control}
                                    name="surname"
                                    label={t("clients.connectedPersonDialog.lastName")}
                                    props={{
                                        fullWidth: true,
                                        size: "small",
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container justifyContent={"center"}>
                            <Grid item xs={6}>
                                <ControlledTextField
                                    control={control}
                                    name="role"
                                    label={t("clients.connectedPersonDialog.role")}
                                    props={{
                                        fullWidth: true,
                                        size: "small",
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container justifyContent={"center"}>
                            <Grid item xs={6}>
                                <ControlledTextField
                                    control={control}
                                    name="phone"
                                    label={t("clients.connectedPersonDialog.phone")}
                                    props={{
                                        fullWidth: true,
                                        size: "small",
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container justifyContent={"center"}>
                            <Grid item xs={6}>
                                <ControlledTextField
                                    control={control}
                                    name="email"
                                    label={t("clients.connectedPersonDialog.email")}
                                    props={{
                                        fullWidth: true,
                                        size: "small",
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid xs={6} item sx={{ mx: "auto", mt: 3 }}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleSubmit(onSubmit, onFormErrors)}
                        >
                            {t("clients.connectedPersonDialog.add")}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </BasicDialog>
    );
}
